import { Flex, Group } from '@mantine/core';
import { PortalButton } from 'components/Button/PortalButton';
import { SendNotificationForm } from 'components/Drawer/SendFormNotification';
import { useDrawerContext } from 'context/hooks';
import { usePatient } from 'hooks/api/useUser';
import { CreateReportsForm } from 'pages/Settings/Forms/CreateReportsForm';
import { CreatePrescription } from 'pages/Main/Patients/CreatePrescription/CreatePrescription';
import { DeactivePrescription } from 'pages/Main/Patients/DeactivePrescription/DeactivatePrescription';
import { BsBell, BsFileEarmark, BsFileEarmarkPlus, BsFileEarmarkX, BsPencil } from 'react-icons/bs';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toPrescriptionPatient } from 'utils/prescription';
import { Notes } from './Overview/HeartRateOverview/Notes/Notes';

export const PatientDetailsActions = () => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();
  const { patientId } = useParams<{ patientId: string }>();
  const { data: patientData } = usePatient({ patientId });

  const prescriptionPatient = patientData && toPrescriptionPatient(patientData);
  const hasActiveGroup = prescriptionPatient?.groups.some((group) => !group.expired) ?? false;

  return (
    <Flex align={'center'} justify={'flex-end'} ml={'auto'} my={'xs'}>
      <Group gap={'xs'}>
        <PortalButton
          Icon={BsFileEarmarkPlus}
          tooltip={{ label: t('navbar_create_prescription'), position: 'bottom' }}
          onClick={() =>
            openDrawer({
              title: t('navbar_create_prescription'),
              content: <CreatePrescription patient={prescriptionPatient} />,
              size: '80%',
            })
          }
        />
        {hasActiveGroup && prescriptionPatient && (
          <PortalButton
            Icon={BsFileEarmarkX}
            tooltip={{ label: t('deactivate_prescription_label'), position: 'bottom' }}
            onClick={() =>
              openDrawer({
                title: t('deactivate_prescription_label'),
                content: <DeactivePrescription patient={prescriptionPatient} />,
              })
            }
          />
        )}
        <PortalButton
          Icon={BsFileEarmark}
          label={t('patients_create_report')}
          onClick={() =>
            openDrawer({
              title: t('patients_create_report'),
              content: <CreateReportsForm patientId={patientId} />,
            })
          }
        />
        <PortalButton
          Icon={BsPencil}
          label={t('notes_label')}
          onClick={() =>
            openDrawer({
              title: t('notes_label'),
              content: <Notes patientId={patientId} />,
            })
          }
        />
        <PortalButton
          Icon={BsBell}
          tooltip={{ label: t('send_notification_label'), position: 'bottom' }}
          onClick={() =>
            openDrawer({
              title: t('send_notification_label'),
              content: <SendNotificationForm patientId={patientId} />,
            })
          }
        />
      </Group>
    </Flex>
  );
};
